import { Factory } from '@infodata-group/inf-commons';
import { ChatMessage } from '../model/chat-message';
import { DtoChatMessageInterface } from '../interface/dto-chat-message.interface';

export class ChatMessageFactory implements Factory<ChatMessage> {
  build(o: DtoChatMessageInterface): ChatMessage {
    const message = new ChatMessage(o.id, o.content, null);
    switch (o.sender) {
      case 'user':
        message.sender = 'user';
        break;
      case 'bot':
        message.sender = 'bot';
        break;
      case 'action':
        message.sender = 'action';
        break;
      default:
        console.log('unknown sender');
    }
    message.origin = o.origin;
    message.response = o.response;

    return message;
  }

  getApi(): string {
    return '../assets/chat-message.json';
  }
}
